export default "__VITE_ASSET__bd335b17__"